import HeroSlider from "./HeroSlider";
import HighlightedProducts from "./HighlightedProducts";

function Home() {
    return (
        <>

<HeroSlider />
            <section className="hero">
                <div className="container">
                    <h1>Your Trusted Partner for Petroleum and Petrochemical products.</h1>
                   <p>Delivering trusted, compliant, and high-performance petroleum and petrochemical products.</p>
                </div>
            </section>

            <section>
                <HighlightedProducts />
            </section>

            {/* <section className="section">
                <div className="container grid">
                    <div className="card">
                        <h3>Petroleum & Energy</h3>
                        <p>Global fuel sourcing and logistics.</p>
                    </div>
                    <div className="card">
                        <h3>Gold & Precious Metals</h3>
                        <p>Compliance-driven metals trading.</p>
                    </div>
                    <div className="card">
                        <h3>Digital Assets</h3>
                        <p>Secure OTC crypto trading services.</p>
                    </div>
                </div>
            </section> */}
        </>
    );
}

export default Home;
